/**
 * Helpers Sentry — nunca bloqueiam o fluxo clínico (AC #7).
 */
export const runSentrySafely = (fn: () => void): void => {
  try {
    fn()
  } catch {
    /* observabilidade não bloqueia consulta */
  }
}

export const runSentrySafelyAsync = async <T>(fn: () => Promise<T>): Promise<T | undefined> => {
  try {
    return await fn()
  } catch {
    return undefined
  }
}

export const parseOptionalSampleRate = (
  raw: string | undefined,
  fallback: number,
): number => {
  if (!raw?.trim()) return fallback
  const value = Number.parseFloat(raw.trim())
  if (!Number.isFinite(value) || value < 0 || value > 1) return fallback
  return value
}

export const resolveSentryEnvironment = (): string => {
  const fromEnv = import.meta.env.VITE_SENTRY_ENVIRONMENT?.trim() || import.meta.env.SENTRY_ENVIRONMENT?.trim()
  if (fromEnv) return fromEnv
  return import.meta.env.MODE || 'development'
}

export const resolveSentryRelease = (): string | undefined => {
  const fromEnv = import.meta.env.VITE_SENTRY_RELEASE?.trim() || import.meta.env.SENTRY_RELEASE?.trim()
  if (fromEnv) return fromEnv
  return typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : undefined
}

export const isSentryReplayEnabled = (): boolean =>
  import.meta.env.VITE_SENTRY_ENABLE_REPLAY === 'true'

export const isSentrySanitizedMode = (): boolean =>
  import.meta.env.VITE_SENTRY_SANITIZED_MODE !== 'false'
